import Bubble from "../../components/Bubble";
import experiencesData from "./data";
import "./experiences.css";

function Experiences() {
  return (
    <section id="experiences">
      <h2 className="subheader">Experiences</h2>
      <div className="experiences_container">
        {experiencesData.reverse().map((item, index) => (
          <Bubble key={index} data={item}></Bubble>
        ))}
      </div>
    </section>
  );
}

export default Experiences;
